module.exports = {
	"inports": {
		"in": {
			"process": "Objectify",
			"port": "in"
		},
		"regexp": {
			"process": "Regexp",
			"port": "in"
		}
	},
	"outports": {
		"out": {
			"process": "Remove",
			"port": "out"
		}
	},
	"groups": [],
	"processes": {
		"Regexp": {
			"component": "core/Split"
		},
		"Objectify": {
			"component": "groups/Objectify"
		},
		"Remove": {
			"component": "groups/RemoveGroups"
		}
	},
	"connections": [
		{
			"src": {
				"process": "Regexp",
				"port": "out"
			},
			"tgt": {
				"process": "Objectify",
				"port": "regexp"
			}
		},
		{
			"src": {
				"process": "Objectify",
				"port": "out"
			},
			"tgt": {
				"process": "Remove",
				"port": "in"
			}
		},
		{
			"src": {
				"process": "Regexp",
				"port": "out"
			},
			"tgt": {
				"process": "Remove",
				"port": "regexp"
			}
		}
	],
	"caseSensitive": false
};